import { render, staticRenderFns } from "./AuthCard.vue?vue&type=template&id=03981662&scoped=true"
import script from "./AuthCard.vue?vue&type=script&lang=js"
export * from "./AuthCard.vue?vue&type=script&lang=js"
import style0 from "./AuthCard.vue?vue&type=style&index=0&id=03981662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03981662",
  null
  
)

export default component.exports